import * as React from "react";
import { forwardRef } from "react";
const SvgType = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-type-icon lucide-type", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 4v16" }), /* @__PURE__ */ React.createElement("path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ React.createElement("path", { d: "M9 20h6" }));
const ForwardRef = forwardRef(SvgType);
export { ForwardRef as ReactComponent };
